module.exports = __webpack_public_path__ + "img/Contract-Cleaning_Services_Long_Short_Terms.a134f4e3.jpg";